import { Menu, message } from "antd";
import { useState } from "react";
import SystemItemView from "./SystemItemView";


export default () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [collapsed, setCollapsed] = useState<boolean>(false)
    //   const [open,setOpen] = useState<boolean>(false)
    const [selectedKeys, setSelectedKeys] = useState<string[]>(['1'])
    const toggleCollapsed = () => {
        setCollapsed(!collapsed)
    };

    // render(): React.ReactNode {
    return (
        <>
            {contextHolder}
            <div style={{ display: 'flex', height: '100%', width: '100%' }}>
                <Menu
                    style={{ width: 256 }}
                    selectedKeys={selectedKeys}
                    onClick={(i) => {
                        console.log('key1 == ', selectedKeys[0])
                        console.log('key == ', i.key)
                        setSelectedKeys([i.key])
                    }}
                    mode="inline"
                    theme="dark"
                    inlineCollapsed={collapsed}
                >
                    <Menu.Item key="1">用户</Menu.Item>
                    <Menu.Item key="2">管理员</Menu.Item>
                </Menu>
                <div style={{ flex: '1', height: '100%', width: '100%', display: 'flex', paddingLeft: '15px', paddingRight: '15px', flexDirection: 'column' }}>
                    <div style={{ paddingBottom: '15px', paddingTop: '15px', display: 'flex' }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'black' }}>
                            {selectedKeys[0] == '1' ? '用户' : '管理员'}
                        </div>
                    </div>
                    <SystemItemView key_={selectedKeys[0].toString()} messageApi={messageApi} />
                </div>
            </div>
        </>
    )
    // }
}